// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JIt6ifyhvDoWEX {\n  display: flex;\n  margin-right: 4px;\n  margin-bottom: 4px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pluginContainer": "JIt6ifyhvDoWEX"
};
export default ___CSS_LOADER_EXPORT___;
